import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/$pathLocale/_guest')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="h-screen w-full flex items-center justify-center auth-page">
      <Outlet />
    </div>
  );
}
